import script from "./AutorizationPersonalRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./AutorizationPersonalRegister.vue?vue&type=script&setup=true&lang=js"

import "./AutorizationPersonalRegister.vue?vue&type=style&index=0&id=2dae56e9&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dae56e9"]])

export default __exports__